import { render, staticRenderFns } from "./PerformanceConcepts.vue?vue&type=template&id=a6335b32&"
import script from "./PerformanceConcepts.vue?vue&type=script&lang=js&"
export * from "./PerformanceConcepts.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceConcepts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports